import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "../../services/security.js";
import auth from "../../services/auth.js";
import env from "../../services/env.js";
import events from "../../services/events.js";
import companies from "../../services/companies.js";

class EventsController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    EventsService,
    CompaniesService,
    SecurityService,
    $rootScope,
    $timeout,
    $window,
    $location,
    $stateParams,
    ScrollService,
    EnvService,
    $scope,
    NgMap,
    branchio
  ) {
    this.name = "events";
    $localStorage.activeStateName = "events";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$location = $location;
    this.$events = EventsService;
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.$scroll = ScrollService;
    this.$stateParams = $stateParams;
    this.$branchio = branchio;
    this.page = "events";
    this.isEzcaterAdmin = false;
    this.logo_has_finished_loading = false;
    this.$window = $window;
    this.BreakException = {};
    this.$maps = NgMap;
    this.busy = false;
    this.thereAreEvents = true;
    this.sort = 0;
    this.jobListResultSetLimit = {value: 10, values: [9, 18, 10, 50]};
    this.nameSort = 0;
    this.$env = EnvService;
    this.events_for_payment = [];
    this.events_for_closure = [];
    this.events = [];
    this.events_for_header = [];
    this.view = 2;
    this.gridViewClass = "btn button btn-grey";
    this.listViewClass = "btn btn-success button";
    this.pages = [];
    this.query = "";
    this.indexOfselectedParam = 0;
    this.currentPageNumber = 1;
    this.queryParams = [
      {id: 0, name: "--Select--"},
      {id: 1, name: "Start date : Oldest"},
      {id: 2, name: "Start date : Newest"},
      {id: 5, name: "A->Z"},
      {id: 6, name: "Z->A"},
    ];

    this.remain_loading_count = 1;

    var _this = this;

    _this.checkToClearQuery(_this.$stateParams.clearQuery);
    _this.isThisEzCaterAdmin();

    if (!SecurityService.isUndefinedOrNull(_this.$stateParams.t)) {
      _this.remain_loading_count++;
      _this.$auth.validateUserByTokenWeb(_this.$stateParams.t).then(
        function (response) {
          _this.remain_loading_count--;
          //console.log("what is the response");
          let user = response.data;
          if (response.data.company.id) {
            dataLayer.push({
              "event category": "business signup",
              "event action": "business validation success",
              accountId: response.data.id,
              event: "businessSignupEvent",
            });
            if (response.data.company.undeletedPaymentInfos.length === 0 && response.data.company.partner) {
              _this.$state.go("accountprofile-payment-information", {
                companyId: response.data.company.id,
                validation: false,
              });
              return;
            }
            _this.$localStorage.logged_user = response.data;
            _this.currentUser = response.data;
            _this.displayHistoryButton();
            _this.handleSessionParams();
            _this.$timeout(function () {
              _this.$rootScope.$emit("UpdateCurrentUser", {
                user: user,
              });
            });
            _this.$timeout(function () {
              _this.remain_loading_count--;
              _this.$rootScope.$emit("GetLogo", user);
            }, 150);

            _this.$timeout(function () {
              _this.$state.go("jobsdashboard");
            }, 300);

            //_this.loadEvents();
          } else {
            _this.$timeout(function () {
              _this.$rootScope.$emit("SetNewUserForJobBoardHeader", {
                user: user,
              });
            });
            //_this.$state.go('jobs',{data: "new_user"});
            _this.$timeout(function () {
              _this.$state.go("jobsdashboard");
            }, 300);
          }
        },
        function (response) {
          _this.remain_loading_count--;
          $state.go("signin");
        }
      );
    } else {
      //console.log("AuthService.isLoggedIn");
      //console.dir(AuthService.isLoggedIn());
      console.log("EVENTS CONTROLLER");
      console.log("EVENTS CONTROLLER");
      console.log("EVENTS CONTROLLER");
      console.log("EVENTS CONTROLLER");

      if (!AuthService.isLoggedIn()) {
        if (_this.$location.$$search.jobType) {
          $state.go("postevent", {
            jobType: _this.$location.$$search.jobType,
            pay: _this.$location.$$search.pay,
            openings: _this.$location.$$search.openings,
          });
        } else {
          $state.go("signin");
        }
        return;
      }
      _this.currentUser = _this.$auth.getUserData();
      //console.log("_this.currentUser");
      //console.dir(_this.currentUser);
      if (_this.currentUser.company.id === null) {
        _this.$state.go("jobs");
        return;
      }
      //_this.checkUserVerifications();
      _this.displayHistoryButton();
      _this.handleSessionParams();
      _this.setLogoBanner();
      _this.loadEvents();
      _this.$timeout(function () {
        _this.$state.go("jobsdashboard");
      }, 300);
    }

    _this.$timeout(function () {
      jQuery("body").removeClass("modal-open");
      $("#ngProgress-container").remove();
    }, 300);

    _this.$timeout(function () {
      _this.$rootScope.$emit("UpdatedCreditCard", {});
    });

    _this.UpdateEventsToPublishedListener = _this.$rootScope.$on("UpdateEventsToPublished", function () {
      _this.currentUser = _this.$auth.getUserData();
      _this.$timeout(function () {
        _this.loadEvents();
      }, 1000);
    });

    _this.SuccessToDeleteEventListener = _this.$rootScope.$on("SuccessToDeleteEvent", function ($event, params) {
      _this.removeTheDeletedEvent(params);
    });

    _this.SuccessPublishEventListener = _this.$rootScope.$on("SuccessPublishEvent", function ($event, params) {
      console.log("SuccessPublishEventListener");
      console.dir(params);
      if (params.status === false) {
        let data = {};
        data.status = params.status;
        data.event = params.event.id;
        _this.markEventAsPublished(data);
        //_this.closePublishModal();
        //_this.unSetLoader()
      } else if (params.message === true) {
        console.log("we need to charge our invoice customer....");
        params.card = null;
        _this.closeModalAndCharge(params);
      } else {
        console.log("we are here...");
        let data = {};
        data.status = params.status;
        data.event = params.event.id;
        _this.markEventAsPublished(data);
      }
    });

    _this.ChargeCreditCardForPostListener = _this.$rootScope.$on("ChargeCreditCardForPost", function ($event, params) {
      console.log("ChargeCreditCardForPost");
      console.dir(params);
      let data = {};
      data.invoice = false;
      data.event = params.event;
      data.status = true;
      data.new_card = true;
      data.card = params.new_card;
      _this.closeModalAndCharge(data);
    });

    _this.CloseCreditCardModalEventsListener = _this.$rootScope.$on("CloseCreditCardModalEvents", function ($event, params) {
      console.log("CloseCreditCardModalEvents");
      console.dir(params);
      _this.closeModalAndCharge(params);
    });

    _this.CloseEtaModalListener = _this.$rootScope.$on("CloseEtaModal", function ($event, params) {
      _this.close_eta_modal(params);
    });

    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
      _this.events.forEach(function (event) {
        if (event.id === params.event.id) {
          event.cost = params.event.cost;
          if (params.action === "Add") {
            event.numberOfOpenings = params.event.numberOfOpenings + params.openings;
          } else {
            event.numberOfOpenings = params.event.numberOfOpenings - params.openings;
          }
          event.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
        }
      });
    });

    _this.SetLogoToEventsPageListener = _this.$rootScope.$on("SetLogoToEventsPage", function ($event, params) {
      _this.set_logo_for_events_banner(params);
    });

    _this.$scope.$on("$destroy", _this.CloseEtaModalListener);
    _this.$scope.$on("$destroy", _this.ChargeCreditCardForPostListener);
    _this.$scope.$on("$destroy", _this.CloseCreditCardModalEventsListener);
    _this.$scope.$on("$destroy", _this.SetLogoToEventsPageListener);
    _this.$scope.$on("$destroy", _this.SuccessPublishEventListener);
    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);
    _this.$scope.$on("$destroy", _this.UpdateEventsToPublishedListener);
    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);

    _this.$timeout(function () {
      $("jobbleheader .main-menu ul li:nth-child(2)").removeClass().addClass("active");
    });
  }

  loadEvents(params) {
    var _this = this;
    _this.$timeout(function () {
      _this.remain_loading_count = 1;
    }, 200);
    //console.log("going to load eventts...");
    //console.dir(_this.$rootScope.sessionParams);

    if (_this.$rootScope.sessionParams) {
      if (!_this.$rootScope.sessionParams.id) {
        _this.selectedParam = 0;
        _this.indexOfselectedParam = 0;
      } else {
        _this.selectedParam = _this.$rootScope.sessionParams.id;
        _this.indexOfselectedParam = _this.$rootScope.sessionParams.id;
      }
      _this.jobListResultSetLimit.value = _this.$rootScope.sessionParams.maxParam;
      params = _this.$rootScope.sessionParams;
    } else {
      _this.indexOfselectedParam = 0;
      _this.selectedParam = 0;
    }
    var offsetParam = null,
      maxParam = null,
      page = null,
      sort = null,
      order = null,
      isCompleted = null,
      isCancelled = null,
      dates = null;

    //console.log("what are params right hehre");
    //console.dir(params);
    if (params) {
      (offsetParam = params.offsetParam),
        (maxParam = params.maxParam),
        (page = params.page),
        (sort = params.sort),
        (order = params.order),
        (isCompleted = params.isCompleted),
        (isCancelled = params.isCancelled),
        (dates = params.dates);
    } else {
      _this.$rootScope.sessionParams = {};
      _this.$rootScope.sessionParams.dates = _this.dates;
      _this.$rootScope.sessionParams.maxParam = 10;
      _this.$rootScope.sessionParams.offsetParam = 0;
      _this.$rootScope.sessionParams.sort = "startTime";
      _this.$rootScope.sessionParams.order = "asc";
      _this.cachedParams = _this.$rootScope.sessionParams;
      _this.$rootScope.sessionParams.page = "live";
      (offsetParam = 0), (maxParam = 10), (page = "live"), (sort = "startTime"), (order = "asc");
    }
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetLoaderDialog", {type: 1, total: 2});
    });
    _this.$companies
      .eventsForEventsPage(_this.currentUser.company.id, offsetParam, maxParam, page, sort, order, isCompleted, isCancelled, dates)
      .then(
        function (data) {
          _this.$timeout(function () {
            _this.remain_loading_count = 0;
          }, 1000);
          _this.events = data.data;
          if (_this.events.length > 0) {
            _this.reconfigurePaginationPages();
          }
          if (_this.events.length > 0 && !_this.currentUser.isVerified) {
            _this.$timeout(function () {
              jQuery("#show-application-global-modal-new").trigger("click");
            });
          }
          _this.$timeout(function () {
            _this.$rootScope.$emit("SetLoaderDialog", {
              type: 2,
              total: 2,
            });
          });
          try {
            _this.events.forEach(function (event) {
              //console.log("event here..");
              //console.dir(event);
              if (event.contactInfo[0]) {
                event.contactInfo = event.contactInfo[0];
              }
              _this.addExtraAttributesToEvent(event);
            });
          } catch (err) {
            //console.log("we have an error...");
            //console.dir(err);
            //_this.$state.go('signin');
          } finally {
            _this.checkAdmin();
            _this.setDatePicker();
            _this.$timeout(function () {
              _this.remain_loading_count = 0;
              _this.$rootScope.events = _this.events;
              _this.$localStorage.events = _this.events;
              _this.$timeout(function () {
                _this.$rootScope.$emit("SetLoaderDialog", {
                  type: 0,
                  total: 2,
                });
              });
            }, 1000);
          }
        },
        function (data) {
          _this.events = [];
          _this.remain_loading_count = 0;
          if (data.status === 401) {
            _this.$state.go("signin");
          } else {
            _this.$timeout(function () {
              jQuery("#show-application-alert").trigger("click");
            }, 100);
          }
        }
      );
  }

  addExtraAttributesToEvent(event) {
    event.status = "Live";
    let startTimeOfJob = null;
    let endTimeOfJob = null;
    let paymentPending = null;
    let startTimeCheck = null;
    let endTimeCheck = null;
    startTimeOfJob = moment(event.startTime).format();
    endTimeOfJob = moment(event.endTime).format();
    startTimeCheck = moment().diff(startTimeOfJob, "minutes") >= -10;
    endTimeCheck = moment().diff(endTimeOfJob, "minutes") <= 10;
    paymentPending = moment().diff(endTimeOfJob, "minutes") >= 10;
    this.setEventsToHeader(event);
    if (event.orderNumber) {
      this.getAcceptedApplicant(event);
      if (event.subEvents[0].deduppedJobbles[0].lastUpdateFront) {
        event.display_eta = true;
      }
    }
    if (!this.currentUser.company.isVerified) {
      event.companyIsNotVerified = true;
      if (!event.subEvents[0].deduppedJobbles[0] || event.subEvents[0].deduppedJobbles[0].isPublished) {
        event.status = "Company Under Review";
        event.listColor = "event-listing-color-red";
        return;
      }
    } else {
      event.companyIsNotVerified = false;
    }
    if (!event.subEvents[0].deduppedJobbles[0]) {
      return;
    }
    if (event.isCancelled) {
      event.status = "Deleted";
      event.listColor = "event-listing-color-black";
      return;
    }
    if (event.isCompleted) {
      event.status = "Completed";
      event.listColor = "event-listing-color-black";
      return;
    }
    if (!event.subEvents[0].deduppedJobbles[0].isPublished && !event.orderNumber) {
      if (!this.currentUser.company.isVerified) {
        event.status = "Pending Approval";
        event.listColor = "event-listing-color-red";
        event.notpublished = true;
        return;
      } else {
        event.status = "Draft";
        event.listColor = "event-listing-color-blue";
        event.notpublished = true;
        if (event.isCancelled) {
          event.status = "Deleted";
          event.listColor = "event-listing-color-black";
          return;
        }
        return;
      }
    } else if (!event.subEvents[0].deduppedJobbles[0].isPublished && event.orderNumber && event.numberOfApprovedApplications === 1) {
      if (event.hired_driver) {
        event.status = "Filled - " + event.hired_driver;
      } else {
        event.status = "Published - Filled";
      }
      event.listColor = "event-listing-color-orange";
      if (paymentPending === true) {
        if (event.hired_driver) {
          //console.log("coming right herelol");
          event.status = "Payment Pending - " + event.hired_driver;
        } else {
          event.status = "Payment Pending";
          _this.check_hired_numbers(event);
        }
        event.listColor = "event-listing-color-red";
        return;
      }
      return;
    } else if (!event.subEvents[0].deduppedJobbles[0].isPublished && event.orderNumber && event.numberOfApprovedApplications === 0) {
      event.status = "Removed from board";
      event.listColor = "event-listing-color-red";
      return;
    }
    if (event.subEvents[0].deduppedJobbles[0].isPublished) {
      if (event.isCompleted || event.isClosed) {
        event.status = "Completed";
        event.listColor = "event-listing-color-black";
        return;
      }
      if (event.isCancelled) {
        event.status = "Deleted";
        event.listColor = "event-listing-color-black";
        return;
      }
      if (startTimeCheck === true && endTimeCheck === true) {
        event.status = "Live";
        event.listColor = "event-listing-color-green";
        return;
      }
      if (paymentPending === true) {
        if (event.isSourcingPost) {
          event.status = "Removed - 30 Days Expired";
        } else {
          event.status = "Payment Pending";
        }
        event.listColor = "event-listing-color-red";
        return;
      } else {
        event.status = "Published";
        event.listColor = "event-listing-color-orange";
      }
    }
  }

  check_hired_numbers(e) {
    var _this = this;
    if (e.numberOfApprovedApplications > 0) {
    } else {
      _this.events_for_closure.push(e);
    }
  }

  getAcceptedApplicant(event) {
    var _this = this;
    let accepted_applicants = [];
    if (event.subEvents[0].deduppedJobbles.length > 0) {
      let applications = event.subEvents[0].deduppedJobbles[0].applications;
      try {
        if (applications) {
          applications.forEach(function (application) {
            if (application) {
              if (application.applicationStatusId) {
                if (application.applicationStatusId === 1) {
                  accepted_applicants.push(application);
                  let lastName = application.applicantLastName.substring(0, 1);
                  event.hired_driver = application.applicantFirstName + " " + lastName + ".";
                } else if (application.applicationStatusId === 4) {
                  if (!event.warningText) {
                    event.warningText = application.applicantFirstName + " " + application.applicantLastName + "has quit the order.";
                  }
                } else if (application.applicationStatusId === 2) {
                  if (event.warningText === "") {
                    event.warningText = application.applicantFirstName + " " + application.applicantLastName + "was rejected from order.";
                  }
                }
              }
            }
          });
        }
      } catch (err) {
        //console.log("error with the applications");
        //console.dir(err);
      }
    }
  }

  getEventDate(raw_date, tz, event) {
    var _this = this;
    var date = new Date(raw_date);
    let user_time_zone = moment.tz.guess();
    let now = moment.tz(user_time_zone);
    if (tz) {
      let nowThere = moment.tz(tz);
      let timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
      let startTimeAsMoment = moment(event.startTime);
      let st = event.startTime;
      let tzid = tz;
      return moment(date).tz(tz).format("MMM DD, YYYY h:mm a");
    }
  }

  clickMagnify() {
    var _this = this;
    _this.$timeout(function () {
      jQuery(".search-container").addClass("s-open");
      jQuery(".search-container").find('input[type="search"]').focus();
    });
  }

  closeSearch() {
    var _this = this;
    _this.$timeout(function () {
      jQuery(".search-container").removeClass("s-open");
      _this.query = "";
    });
  }

  gotoEventOverview(event) {
    if (event.leave_page_prevent) {
      return;
    }

    if (!event.companyIsNotVerified) {
      this.$state.go("eventoverview", {eventId: event.id});
    }
  }

  setEvent(event) {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetEventToEventDialog", {event: event});
    });
  }

  setEventOpenings(event) {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetEventToEventDialog", {event: event});
    });
  }

  getLocation(event) {
    var location = "";
    //
    // console.log("getLocation");
    // console.dir(event);

    if (event.contactInfo) {
      location = event.contactInfo.streetLine1 + " " + event.contactInfo.city + " " + event.contactInfo.state + " " + event.contactInfo.zipCode;
    } else {
      location = event.contactInfo.streetLine1 + " " + event.contactInfo.city + " " + event.contactInfo.state + " " + event.contactInfo.zipCode;
    }

    /*
	  if (){

	  } else if (!this.$security.isUndefinedOrNull(event.firstLocation)) {
		  location = event.firstLocation.streetLine1;
		  if (event.firstLocation.city != null && event.firstLocation.city != '') {
			  location += ' ' + event.firstLocation.city;
		  }
		  if (event.firstLocation.state != null && event.firstLocation.state != '') {
			  location += ', ' + event.firstLocation.state;
		  }
	  } else {
		  if(!event.contactInfo){
			  //console.log("no contaacatinfo..");
			  //console.dir(event);
		  }else{
			  location = event.contactInfo.streetLine1 + " " + event.contactInfo.city + " " + event.contactInfo.state + " " + event.contactInfo.zipCode;
		  }
	  }
	  */
    return location;
  }

  calculatePagination(params, scrolled) {
    var totals = null;
    var paginationNum = 0;
    var divisibleBy = 0;
    this.pages = [];
    if (params) {
      if (params.eventCount) {
        if (scrolled) {
          this.jobListResultSetLimit.value = params.eventCount;
        } else {
          paginationNum = params.eventCount;
        }
      }
      if (params.page === "history") {
        totals = this.currentUser.company.totalNumberOfCloseEvents;
      } else {
        if (params.page === "cancelled") {
          totals =
            this.currentUser.company.totalNumberOfEvents -
            (this.currentUser.company.totalNumberOfNonCloseEvents + this.currentUser.company.totalNumberOfCloseEvents);
        } else {
          totals = this.currentUser.company.totalNumberOfNonCloseEvents;
        }
      }
    } else {
      totals = this.currentUser.company.totalNumberOfNonCloseEvents;
      var params = {};
      params.eventCount = this.jobListResultSetLimit.value;
    }
    if (this.$security.isUndefinedOrNull(this.currentUser.company)) {
      this.pages.push(1);
    } else {
      if (params.eventCount) {
        divisibleBy = params.eventCount;
      } else {
        divisibleBy = this.events.length;
      }
      var numberOfEvents = Math.ceil(totals / divisibleBy);
      for (var i = 0; i < numberOfEvents; i++) {
        this.pages.push(i + 1);
      }
    }
  }

  paginate(pageNumber) {
    if (pageNumber < 1 || pageNumber > this.pages.length) {
      return;
    }
    this.currentPageNumber = pageNumber;
    this.remain_loading_count = 1;
    var companyId = this.currentUser.company.id;
    this.cachedParams.offsetParam = pageNumber * this.events.length - this.events.length;
    this.$rootScope.sessionParams.offsetParam = this.cachedParams.offsetParam;
    this.loadEvents();
  }

  startDateChange() {
    var _this = this;
    _this.events = [];
    let tempDate = new Date(_this.startDate);
    let startTime = null;
    let endtime = null;
    let startDateMoment = moment.utc(moment(tempDate).startOf("day").format()).format();
    let endDateMoment = moment.utc(moment(tempDate).endOf("day").format()).format();
    _this.dates = {start: startDateMoment, end: endDateMoment};
    _this.$rootScope.sessionParams.dates = _this.dates;
    _this.thereAreEvents = true;
    _this.loadEvents();
  }

  sortReq(sortVal, orderVal) {
    var _this = this;
    var offsetParam = 0;
    var maxParam = 10;
    var page = "live";
    this.$companies.eventsForEventsPage(_this.currentUser.company.id, offsetParam, maxParam, page, sortVal, orderVal).then(
      function (data) {
        _this.events = data.data;
        try {
          _this.events.forEach(function (event) {
            _this.addExtraAttributesToEvent(event);
          });
        } catch (err) {
          //console.log("error in events loop");
        } finally {
          //_this.setEventsToHeader();
        }
        _this.remain_loading_count--;
      },
      function (data) {
        _this.events = [];
      }
    );
  }

  sortTable(sortVal, type) {
    var _this = this;
    _this.remain_loading_count++;
    if (type === "date") {
      _this.nameSort = 0;
      if (sortVal === "desc") {
        _this.sort = 1;
        _this.sortReq("startTime", "desc");
      } else {
        _this.sort = 2;
        _this.sortReq("startTime", "asc");
      }
    } else {
      _this.sort = 0;
      if (sortVal === "desc") {
        _this.nameSort = 1;
        _this.sortReq("name", "desc");
      } else {
        _this.nameSort = 2;
        _this.sortReq("name", "asc");
      }
    }
  }

  changeView(view) {
    var _this = this;
    switch (view) {
      case 1:
        _this.view = 1;
        _this.gridViewClass = "btn btn-success button";
        _this.listViewClass = "btn button btn-grey";
        break;
      case 2:
        _this.view = 2;
        _this.gridViewClass = "btn button btn-grey";
        _this.listViewClass = "btn btn-success button";
        break;
    }
  }

  queryChanged() {
    var _this = this;
    var params = {};
    params.isCancelled = null;
    params.isCompleted = null;
    if (_this.page === "history") {
      params.isCancelled = false;
      params.isCompleted = true;
    }
    if (_this.page === "cancelled") {
      params.isCancelled = true;
      params.isCompleted = false;
    }
    //console.log("what is the selected param");
    //console.dir(_this.selectedParam);
    switch (_this.selectedParam) {
      case 0:

      case 1:
        (params.offsetParam = 0),
          (params.maxParam = _this.jobListResultSetLimit.value),
          (params.page = _this.page),
          (params.sort = "startTime"),
          (params.order = "asc"),
          (params.id = 1),
          (params.dates = _this.dates);
        _this.cachedParams = params;
        _this.$rootScope.sessionParams = params;
        _this.loadEvents(params);
        break;
      case 2:
        (params.offsetParam = 0),
          (params.maxParam = _this.jobListResultSetLimit.value),
          (params.page = _this.page),
          (params.sort = "startTime"),
          (params.order = "desc"),
          (params.id = 2),
          (params.dates = _this.dates);
        _this.cachedParams = params;
        _this.$rootScope.sessionParams = params;
        _this.loadEvents(params);
        break;
      case 3:
        (params.offsetParam = 0),
          (params.maxParam = _this.jobListResultSetLimit.value),
          (params.page = _this.page),
          (params.sort = "dateCreated"),
          (params.order = "desc"),
          (params.id = 3),
          (params.dates = _this.dates);
        _this.cachedParams = params;
        _this.$rootScope.sessionParams = params;
        _this.loadEvents(params);
        break;
      case 4:
        (params.offsetParam = 0),
          (params.maxParam = _this.jobListResultSetLimit.value),
          (params.page = _this.page),
          (params.sort = "dateCreated"),
          (params.order = "asc"),
          (params.id = 4),
          (params.dates = _this.dates);
        _this.cachedParams = params;
        _this.$rootScope.sessionParams = params;
        _this.loadEvents(params);
        break;
      case 5:
        (params.offsetParam = 0),
          (params.maxParam = _this.jobListResultSetLimit.value),
          (params.page = _this.page),
          (params.sort = "name"),
          (params.order = "asc"),
          (params.id = 5),
          (params.dates = _this.dates);
        _this.cachedParams = params;
        _this.$rootScope.sessionParams = params;
        _this.loadEvents(params);
        break;
      case 6:
        (params.offsetParam = 0),
          (params.maxParam = _this.jobListResultSetLimit.value),
          (params.page = _this.page),
          (params.sort = "name"),
          (params.order = "desc"),
          (params.id = 6),
          (params.dates = _this.dates);
        _this.cachedParams = params;
        _this.$rootScope.sessionParams = params;
        _this.loadEvents(params);
        break;
      case 7:
        (params.offsetParam = 0),
          (params.maxParam = 9),
          (params.page = _this.page),
          (params.sort = "startTime"),
          (params.order = "asc"),
          (params.dates = _this.dates);
        _this.cachedParams = params;
        _this.$rootScope.sessionParams = params;
        //console.log("what are the params as we go into the 7th case");
        //console.dir(params);
        _this.loadEvents(params);
        break;
      case 8:
        _this.jobListResultSetLimit.value = 9;
        (params.offsetParam = 0),
          (params.maxParam = _this.jobListResultSetLimit.value),
          (params.page = _this.page),
          (params.sort = "startTime"),
          (params.order = "desc"),
          (params.id = 0),
          (params.dates = _this.dates);
        _this.cachedParams = params;
        _this.$rootScope.sessionParams = params;
        _this.loadEvents(params);
        break;
      case 9:
        (params.offsetParam = 0),
          (params.maxParam = _this.jobListResultSetLimit.value),
          (params.page = _this.page),
          (params.sort = "lastUpdated"),
          (params.order = "desc"),
          (params.id = 0),
          (params.dates = _this.dates);
        _this.cachedParams = params;
        _this.$rootScope.sessionParams = params;
        _this.loadEvents(params);

        break;
    }
  }

  changeEventListing(x) {
    var _this = this;

    switch (x) {
      case 1:
        _this.page = "events";
        _this.selectedParam = 7;
        _this.pageStatus = "open";
        _this.endOfList = _this.currentUser.company.totalNumberOfNonCloseEvents;
        _this.queryChanged();
        _this.$timeout(function () {
          $(".job-container .job-sidebar .list-job li:nth-child(2)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(3)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(1)").addClass("job-active");
        });
        break;

      case 2:
        _this.page = "history";
        _this.selectedParam = 8;
        _this.queryChanged();
        _this.pageStatus = "completed";
        _this.endOfList = _this.currentUser.company.totalNumberOfCloseEvents;
        _this.$timeout(function () {
          $(".job-container .job-sidebar .list-job li:nth-child(1)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(3)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(2)").addClass("job-active");
        });
        break;

      case 3:
        _this.page = "cancelled";
        _this.selectedParam = 9;
        _this.jobListResultSetLimit.value = 9;
        _this.queryChanged();
        _this.pageStatus = "cancelled";
        _this.endOfList =
          _this.currentUser.company.totalNumberOfEvents -
          (_this.currentUser.company.totalNumberOfNonCloseEvents + _this.currentUser.company.totalNumberOfCloseEvents);
        _this.$timeout(function () {
          $(".job-container .job-sidebar .list-job li:nth-child(1)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(2)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(3)").addClass("job-active");
        });
        break;
    }
  }

  scrollEvents() {
    var _this = this;

    let sort = null;
    let order = null;
    let scrollMax = 9;
    if (_this.$rootScope.sessionParams) {
      scrollMax = _this.$rootScope.sessionParams.maxParam + 1;
      sort = _this.$rootScope.sessionParams.sort;
      order = _this.$rootScope.sessionParams.order;
    }
    if (!_this.endOfList) {
      _this.endOfList = _this.currentUser.company.totalNumberOfNonCloseEvents;
    }
    if (_this.events.length !== _this.endOfList && _this.thereAreEvents) {
      _this.busy = true;
      _this.$scroll
        .loadMoreEvents(
          _this.currentUser.company.id,
          _this.events.length,
          3,
          _this.$rootScope.sessionParams.page,
          _this.$rootScope.sessionParams.sort,
          _this.$rootScope.sessionParams.order,
          _this.$rootScope.sessionParams.isCancelled,
          _this.$rootScope.sessionParams.isCompleted,
          _this.$env,
          1,
          _this.$rootScope.sessionParams.dates
        )
        .then(function (response) {
          var events = response.data;
          if (events.length === 0) {
            _this.thereAreEvents = false;
          }
          try {
            if (event.status !== "error") {
              if (events) {
                events.forEach(function (event) {
                  if (event.contactInfo[0]) {
                    event.contactInfo = event.contactInfo[0];
                  }
                  _this.addExtraAttributesToEvent(event);
                  _this.events.push(event);
                });
              }
            } else {
              //console.log("minor error?");
            }
          } catch (err) {
            //console.log("error while paginating scroll");
            //console.dir(err);
          } finally {
            _this.reconfigurePaginationPages();
            _this.busy = false;
          }
        });
    }
  }

  setDatePicker() {
    var _this = this;

    setTimeout(function () {
      jQuery("#datepickerevents").datepicker({
        showOn: "both",
        buttonImage: "/app/vendor/images/calender.png",
        buttonImageOnly: true,
        buttonText: "Select date",
        dateFormat: "M dd, yy",
      });
    }, 100);
  }

  reconfigurePaginationPages() {
    var _this = this;
    var divisible = null;

    _this.pages = [];

    if (_this.page === "events" || !_this.page) {
      divisible = this.currentUser.company.totalNumberOfNonCloseEvents;
      _this.pageStatus = "open";
    }

    if (_this.page === "history") {
      divisible = this.currentUser.company.totalNumberOfCloseEvents;
      _this.pageStatus = "completed";
    }

    if (_this.page === "cancelled") {
      divisible =
        this.currentUser.company.totalNumberOfEvents -
        (this.currentUser.company.totalNumberOfNonCloseEvents + this.currentUser.company.totalNumberOfCloseEvents);
      _this.pageStatus = "cancelled";
    }
    var numberOfEvents = Math.ceil(divisible / _this.events.length);
    for (var i = 0; i < numberOfEvents; i++) {
      _this.pages.push(i + 1);
    }
  }

  limitChanged() {
    var _this = this;
    if (_this.$rootScope.sessionParams) {
      _this.$rootScope.sessionParams.maxParam = _this.jobListResultSetLimit.value;
    }
    _this.loadEvents();
  }

  checkVerificationStatus() {
    var _this = this;
    _this.remain_loading_count--;
    _this.$auth.reloadCurrentUser();
    _this.$timeout(function () {
      _this.currentUser = _this.$auth.getUserData();
    }, 1500);
    _this.$timeout(function () {
      if (_this.currentUser.isVerified) {
        _this.remain_loading_count++;
        _this.currentUser = _this.$auth.getUserData();
        _this.loadEvents();
        jQuery("#show-application-global-modal-new").trigger("click");
      } else {
        _this.remain_loading_count++;
        _this.verificationError =
          "Your email confirmation has yet to be confirmed. Please find the email titled 'Please Verify Your Email Address' and click the confirmation link inside.";
      }
    }, 2000);
  }

  displayHistoryButton() {
    var _this = this;
    if (_this.currentUser) {
      if (_this.currentUser.company.totalNumberOfCloseEvents > 0) {
        _this.showHistoryButton = true;
      }
    }
  }

  slideDownMenu(index) {
    var _this = this;
    var selector = "#dropdownMenuHidden-" + index;
    _this.$timeout(function () {
      jQuery(selector).show("fast");
    });
  }

  removeTheDeletedEvent(params) {
    var _this = this;
    if (_this.events.indexOf()) {
      var o = _this.events.filter(function (obj) {
        return obj.id !== params.event;
      });
      _this.$timeout(function () {
        _this.events = o;
      });
    }
    _this.currentUser.company.totalNumberOfNonCloseEvents = _this.currentUser.company.totalNumberOfNonCloseEvents - 1;
  }

  markEventAsPublished(params) {
    var _this = this;
    var events = _this.events;
    var target = null;
    try {
      events.forEach(function (el) {
        if (el.id === params.event) {
          target = el;
          throw _this.BreakException;
        }
      });
    } catch (e) {
      target.notpublished = false;
      if (params.status === true) {
        target.subEvents[0].deduppedJobbles[0].isPublished = true;
      } else {
        target.subEvents[0].deduppedJobbles[0].isPublished = false;
      }
      _this.addExtraAttributesToEvent(target);
      if (params.do_not_close !== true) {
        _this.closePublishModal();
      }
      _this.unSetLoader();
    }
  }

  setParamDateToDatePicker(start_date) {
    var _this = this;
    let date_temp = new Date(start_date);
    _this.startDate = moment(date_temp).format("MMM DD, YYYY");
  }

  handleSessionParams() {
    var _this = this;
    //console.log("handleSessionParams");
    //console.dir(_this.$rootScope.sessionParams);
    if (_this.$rootScope.sessionParams) {
      if (_this.$rootScope.sessionParams.dates) {
        _this.dates = _this.$rootScope.sessionParams.dates;
        _this.setParamDateToDatePicker(_this.$rootScope.sessionParams.dates.start);
      }
      if (_this.$rootScope.sessionParams.isCompleted) {
        _this.page = "history";
        _this.$timeout(function () {
          $(".job-container .job-sidebar .list-job li:nth-child(1)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(3)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(2)").addClass("job-active");
        });
      } else if (_this.$rootScope.sessionParams.isCancelled) {
        _this.page = "cancelled";
        _this.$timeout(function () {
          $(".job-container .job-sidebar .list-job li:nth-child(1)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(2)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(3)").addClass("job-active");
        });
      } else {
        _this.$timeout(function () {
          $(".job-container .job-sidebar .list-job li:nth-child(2)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(3)").removeClass("job-active");
          $(".job-container .job-sidebar .list-job li:nth-child(1)").addClass("job-active");
        });
      }
    }
  }

  checkUserVerifications() {
    var _this = this;

    if (!_this.$rootScope.globalModalType) {
      _this.$rootScope.globalModalType = {};
    }
    _this.$timeout(function () {
      _this.$rootScope.globalModalType.type = 4;
    });
    if (!_this.currentUser.isVerified) {
      _this.$timeout(function () {
        jQuery("#modal-verify-email-click-redesign").trigger("click");
      }, 300);
    } else if (!_this.currentUser.company.isVerified) {
      _this.companyHasBeenVerified = false;
      _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(
        function (response) {
          if (response.data.company.isVerified) {
            _this.$localStorage.logged_user = response.data;
            _this.currentUser = response.data;
            _this.events.forEach(function (event) {
              _this.addExtraAttributesToEvent(event);
            });
          }
        },
        function (error) {
          //console.log('error from validate');
          //console.dir(error);
        }
      );
    } else {
      //console.log('are we verified down here?2');
      _this.companyHasBeenVerified = true;
    }
  }

  setLogoBanner() {
    var _this = this;
    if (_this.currentUser) {
      ////console.log('set logo banner');
      ////console.dir(_this.currentUser.company.companyLogoUri);
      ////console.dir(_this.$rootScope.imgFromProfilePage);
    }
  }

  validateCurrentUser() {
    var _this = this;
    console.log("validateCurrentUservalidateCurrentUservalidateCurrentUservalidateCurrentUser");
    console.dir(_this.currentUser);
    _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(
      function (response) {
        console.log("what is the response now...");
        console.dir(response.data);
        _this.currentUser = response.data;
        _this.currentUser.company.paymentInfos = response.data.company.undeletedPaymentInfos;
        _this.$localStorage.logged_user = _this.currentUser;
      },
      function (error) {}
    );
  }

  inboxLink(id) {
    var _this = this;
    if (_this.$rootScope.channelsHaveLoaded && !_this.$rootScope.channels) {
      alert("This account has no active messages. If you think there are active messages please refresh the page.");
    } else {
      _this.$timeout(function () {
        _this.$location.path("/messages/event/" + id);
      });
    }
  }

  checkAdmin() {
    var _this = this;
    if (_this.currentUser) {
      _this.admin = _this.$auth.isAdmin();
      //console.log("what is this admin");
      //console.dir(_this.admin);
    }
  }

  isThisEzCaterAdmin() {
    var _this = this;
    let isEzAdmin = null;
    let user = _this.$auth.getUserData();
    if (user) {
      if (user.email.indexOf("jobbleapp.com") > -1 && user.email.indexOf("ezcater") > -1) {
        _this.isEzcaterAdmin = true;
      } else {
        _this.isEzcaterAdmin = false;
        _this.getCurrentDate();
      }
    }
  }

  getCurrentDate() {
    var _this = this;
    _this.startDate = "";
  }

  clearDate() {
    var _this = this;
    _this.startDate = "";
    _this.events = [];
    _this.dates = {};
    _this.$rootScope.sessionParams.dates = {};
    _this.loadEvents();
  }

  setEventsToHeader(event) {
    var _this = this;
    _this.events_for_header.push(event);
    if (_this.events_for_header.length === _this.events.length) {
      let events = _this.events_for_header;
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetEventsToScroller", {
          events: events,
        });
      });
    }
  }

  set_logo_for_events_banner(logo_url) {
    var _this = this;
    if (_this.currentUser) {
      _this.$timeout(function () {
        _this.currentUser.company.companyLogoUri = logo_url;
        _this.$rootScope.imgFromProfilePage = logo_url;
        _this.currentUser.company.companyLogoUri = logo_url;
        _this.logo_has_finished_loading = true;
        _this.$rootScope.$emit("UpdateCurrentUser", {
          user: _this.currentUser,
        });
      });
    }
  }

  toggle_eta(type, event, index) {
    var _this = this;
    let event_id = event.id;
    let jobble_id = event.subEvents[0].deduppedJobbles[0].id;
    if (type === 1) {
      let selector = "#eta-locator-id-" + index + ".eta-locator";
      _this.$timeout(function () {
        $(selector).removeClass("rotate-up");
        $(selector).addClass("rotate-down");
        _this.display_eta_modal(event, index);
        _this.set_focus_to_map(event, index);
        _this.load_eta_data(event_id, jobble_id, index);
      });
    } else {
    }
  }

  load_eta_data(event_id, jobble_id, index) {
    var _this = this;
    _this.driver = {};
    _this.positions = [];
    _this.setLoader();
    _this.$events.load_eta_data(event_id, jobble_id).then(
      function (response) {
        _this.handle_eta_response(response.data, event_id, jobble_id, index);
      },
      function (error) {
        alert("Error getting tracking information");
      }
    );
  }

  handle_eta_response(data, event, jobble, index) {
    var _this = this;
    _this.driver.current_loc = {};
    _this.driver.current_loc.lat = data.currentLocation.lat;
    _this.driver.current_loc.lng = data.currentLocation.lng;
    _this.init_eta_map(data, event, jobble, index);
  }

  set_refresh_counter(jobble) {
    var _this = this;
    let last_updated = jobble.currentLocation.lastUpdateFront;
    let now = moment().format();
    last_updated = moment(last_updated).format();
    let diff = moment(now).diff(moment(last_updated), "seconds");
    let minutes = Math.floor(diff / 60);
    let seconds_left_over = diff % 60;
    if (diff > 600) {
      _this.display_time = "Tracking data has not been updated for " + minutes + " minutes";
    } else {
      _this.display_time = "Last updated " + minutes + " minute(s) and " + seconds_left_over + " seconds ago.";
    }
  }

  refresh_eta_modal(index, event) {
    var _this = this;
  }

  get_address(data) {
    var _this = this;
  }

  set_user_location(data, event, jobble, index) {
    var _this = this;

    let lat = data.currentLocation.lat;
    let lng = data.currentLocation.lng;
    let current_location = {};
    let current_loc_latlng = {lat: lat, lng: lng};
    let current_user_marker = "/app/vendor/images/car_gps.png";
    let marker = new google.maps.Marker({
      title: "Driver GPS",
      icon: "/app/vendor/images/car_gps.png",
      position: current_loc_latlng,
      id: null,
      showMe: true,
      checkin: null,
    });
    _this.positions.push(marker);
    _this.set_center_of_map(marker);
  }

  set_center_of_map(marker) {
    var _this = this;
    _this.$timeout(function () {
      marker.setMap(_this.map);
    }, 500);
  }

  display_eta_modal(event, index) {
    var _this = this;
    let selector = "#eta-target-" + index + ".eta-map-holder";
    _this.$timeout(function () {
      $(selector).show("fast");
    });
  }

  set_focus_to_map(event, index) {
    var _this = this;
    let selector = "#eta-target-" + index;
    _this.$timeout(function () {
      $(selector).focus();
    }, 300);
  }

  clicking_map(event, index) {
    var _this = this;
    let selector = "#eta-target-" + index;
    _this.$timeout(function () {
      $(selector).focus();
    });
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  toggle_eta_hover(type, event, index) {
    var _this = this;
    event.leave_page_prevent = true;
    /*
	  _this.$timeout(function(){
		  event.leave_page_prevent=false;
	  });
	  */
  }

  toggle_eta_leave(type, event, index) {
    var _this = this;
    event.leave_page_prevent = false;
  }

  init_eta_map(data, event, jobble, index) {
    var _this = this;
    if (_this.map) {
      //console.log("lets check the markers each map load");
      //console.dir(_this.map.markers);
      //console.dir(_this.map.markers.length);
      //console.dir(_this.positions);
    }
    _this.$timeout(function () {
      _this.$maps.getMap({id: "map-eta"}).then(
        function (map) {
          _this.map = map;
          _this.set_user_location(data, event, jobble, index);
          _this.set_pickup_and_dropoff(data, event, jobble, index);
          /*
			  _this.map = map;
			  if (map.markers){
				  _this.clearMarkers();
			  }
			   */
        },
        function (error) {
          //console.log("maps error");
          //console.dir(error);
        }
      );
    }, 500);
  }

  set_pickup_and_dropoff(data, event, jobble, index) {
    var _this = this;
    //console.log("set_pickup_and_dropoff");
    //console.dir(data);
    //console.dir(event);
    //console.dir(jobble);
    //console.dir(index);
    let addresses = {};
    let shifts = _this.sort_shifts(data.shifts);
    let pickup_data = {};
    pickup_data.street = shifts[0].contactInfo.streetLine1;
    pickup_data.state = shifts[0].contactInfo.state;
    pickup_data.city = shifts[0].contactInfo.city;
    pickup_data.zipcode = shifts[0].contactInfo.zipCode;
    addresses.pickup_address = pickup_data.street + ", " + pickup_data.city + ", " + pickup_data.state;
    let dropoff_data = {};
    dropoff_data.street = shifts[1].contactInfo.streetLine1;
    dropoff_data.state = shifts[1].contactInfo.state;
    dropoff_data.city = shifts[1].contactInfo.city;
    dropoff_data.zipcode = shifts[1].contactInfo.zipCode;
    addresses.dropoff_address = dropoff_data.street + ", " + dropoff_data.city + ", " + dropoff_data.state;
    _this.set_pickup_location(addresses, data, index);
    _this.set_dropoff_location(addresses, data, index, event);
  }

  set_pickup_location(addresses, data, index) {
    var _this = this;
    //console.log("positions before pickup");
    //console.dir(_this.positions);
    _this.$timeout(function () {
      _this.geocoder = new google.maps.Geocoder();
      _this.geocoder.geocode({address: addresses.pickup_address}, function (results, status) {
        //console.log("pick up loc");
        //console.dir(results[0].geometry.location.lat());
        //console.dir(results[0].geometry.location.lng());
        if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
          let locmrker = {};
          let location = results[0].geometry.location;
          let lat_lng = {
            lat: location.lat(),
            lng: location.lng(),
          };
          let marker = new google.maps.Marker({
            title: "Pickup Location",
            icon: "/app/vendor/images/resst.png",
            position: lat_lng,
            id: null,
            showMe: true,
            checkin: null,
          });
          _this.positions.push(marker);
        }
      });
      //console.log("positions after pick up");
      //console.dir(_this.positions);
    }, 400);
  }

  set_dropoff_location(addresses, data, index, event) {
    var _this = this;
    //console.log("set_dropoff_location");
    //console.dir(addresses);
    //console.dir(data);
    //console.log("positions before drop off");
    //console.dir(_this.positions);
    _this.$timeout(function () {
      _this.geocoder = new google.maps.Geocoder();
      _this.geocoder.geocode({address: addresses.dropoff_address}, function (results, status) {
        //console.log("drop off loc");
        //console.dir(results);
        if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
          //console.dir(results[0].geometry.location.lat());
          //console.dir(results[0].geometry.location.lng());
          let locmrker = {};
          let location = results[0].geometry.location;
          let lat_lng = {
            lat: location.lat(),
            lng: location.lng(),
          };
          let marker = new google.maps.Marker({
            title: "Dropoff Location",
            icon: "/app/vendor/images/off.png",
            position: lat_lng,
            id: null,
            showMe: true,
            checkin: null,
          });
          _this.positions.push(marker);
        }
      });
      //console.log("positions after drop off");
      //console.dir(_this.positions);
      _this.clicking_map(event, index);
    }, 800);
    _this.format_table(addresses, data);
  }

  format_table(addresses, data) {
    var _this = this;
    let modal_table_data = {};
    modal_table_data.pickup_shift = {};
    modal_table_data.dropoff_shift = {};
    modal_table_data.pickup_shift.time_zone = data.shifts[0].contactInfo.place.timeZoneId;
    modal_table_data.pickup_shift.time_zone_name = data.shifts[0].contactInfo.place.timeZoneName;
    if (data.shifts[0].pickupEta) {
      modal_table_data.pickup_shift.eta = moment(data.shifts[0].pickupEta).format("hh:mm A");
    } else {
      modal_table_data.pickup_shift.eta = "N/A";
    }
    //console.log("modal_table_data.pickup_shift.eta");
    //console.dir(moment(data.shifts[0].pickupEta).format("hh:mm A"));
    if (data.shifts[0].checkInTime) {
      modal_table_data.pickup_shift.check_in_time = moment(data.shifts[0].checkInTime).format("hh:mm A");
    } else {
      modal_table_data.pickup_shift.check_in_time = "N/A";
    }
    if (data.shifts[0].checkOutTime) {
      modal_table_data.pickup_shift.check_out_time = moment(data.shifts[0].checkOutTime).format("hh:mm A");
    } else {
      modal_table_data.pickup_shift.check_out_time = "N/A";
    }
    modal_table_data.pickup_shift.expected_arrival_time = moment(data.shifts[0].timeInterval.startTime).format("hh:mm A");
    modal_table_data.pickup_shift.location = data.shifts[0].location;
    modal_table_data.dropoff_shift.time_zone = data.shifts[1].contactInfo.place.timeZoneId;
    modal_table_data.dropoff_shift.time_zone_name = data.shifts[1].contactInfo.place.timeZoneName;
    if (data.shifts[1].dropoffEta) {
      modal_table_data.dropoff_shift.eta = moment(data.shifts[1].dropoffEta).format("hh:mm A");
    } else {
      modal_table_data.dropoff_shift.eta = "N/A";
    }

    modal_table_data.dropoff_shift.expected_arrival_time = moment(data.shifts[1].timeInterval.startTime).format("hh:mm A");
    if (data.shifts[1].checkInTime) {
      modal_table_data.dropoff_shift.check_in_time = moment(data.shifts[1].checkInTime).format("hh:mm A");
    } else {
      modal_table_data.dropoff_shift.check_in_time = "N/A";
    }
    if (data.shifts[1].checkOutTime) {
      modal_table_data.dropoff_shift.check_out_time = moment(data.shifts[1].checkOutTime).format("hh:mm A");
    } else {
      modal_table_data.dropoff_shift.check_out_time = "N/A";
    }
    modal_table_data.dropoff_shift.location = data.shifts[1].location;
    _this.modal_data = modal_table_data;
    _this.set_refresh_counter(data);
    _this.unSetLoader();
    //_this.pickup_shift=pickup_shift;
    //let time_zone =
  }

  sort_shifts(shifts) {
    var _this = this;
    shifts.sort(function (a, b) {
      return new Date(a.timeInterval.startTime) - new Date(b.timeInterval.startTime);
    });
    return shifts;
  }

  blur_off_map(index, event) {
    var _this = this;
    let selector = "#eta-target-" + index;
    _this.$timeout(function () {
      $(selector).focus();
    }, 300);
  }

  refresh_map_data(event, index) {
    var _this = this;
    let event_id = event.id;
    let jobble_id = event.subEvents[0].deduppedJobbles[0].id;
    _this.load_eta_data(event_id, jobble_id, index);
  }

  close_eta_modal(index, event) {
    var _this = this;

    let selector = "#eta-target-" + index + ".eta-map-holder";
    let selector2 = "#eta-locator-id-" + index + ".eta-locator";
    _this.$timeout(function () {
      $(selector).hide("fast");
      $(selector2).removeClass("rotate-down");
      $(selector2).addClass("rotate-up");
      event.leave_page_prevent = false;
    });
  }

  copyJobbleID(event) {
    var _this = this;
    console.dir("copyJobbleID");
    console.dir(event);

    const origin = this.$branchio.getOrigin();

    var text_to_share = origin + "/job/" + event.subEvents[0].deduppedJobbles[0].id;
    // create temp element
    var copyElement = document.createElement("span");
    copyElement.appendChild(document.createTextNode(text_to_share));
    copyElement.id = "tempCopyToClipboard";
    angular.element(document.body.append(copyElement));
    // select the text
    var range = document.createRange();
    range.selectNode(copyElement);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    // copy & cleanup
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    copyElement.remove();
  }

  copyEventID(event) {
    var _this = this;
    console.log("copyEventID");
    console.dir(event);
    var text_to_share = event.id;
    // create temp element
    var copyElement = document.createElement("span");
    copyElement.appendChild(document.createTextNode(text_to_share));
    copyElement.id = "tempCopyToClipboard";
    angular.element(document.body.append(copyElement));
    // select the text
    var range = document.createRange();
    range.selectNode(copyElement);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    // copy & cleanup
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    copyElement.remove();
  }

  setPublishType(type, event) {
    var _this = this;

    var publish_status = null;
    var invoice = _this.currentUser.company.payByInvoice;

    console.log("setPublishType");
    console.dir(event);
    console.dir(type);

    if (event.isSourcingPost && type !== 1) {
      //console.log("trying to publish aa sourcing posts....");
      //console.dir(event);
      if (invoice === true) {
        /*
         * If an invoice customer, display #modal-publish-event explaining that
         * once published, they will be charged $50.00
         */
        console.log("we are in invoice");

        if (type === 2) {
          publish_status = false;
        } else {
          publish_status = true;
        }

        _this.$timeout(function () {
          $("#modal-publish-event").modal();
        }, 300);

        console.log("publish_status");
        console.dir(publish_status);

        _this.$timeout(function () {
          _this.$rootScope.$emit("SetPublishType", {
            status: publish_status,
            message: true,
          });
        });
      } else {
        /*
         * Regular customer we need to
         */

        console.log("_this.currentUser.company");
        console.dir(_this.currentUser.company);

        if (_this.currentUser.company.undeletedPaymentInfos.length === 0) {
          _this.$timeout(function () {
            _this.$rootScope.$emit("SetPayForPostData", {
              cards: false,
              event: event,
            });
            $("#modal-add-card").modal();
          }, 1000);
        } else {
          _this.$timeout(function () {
            _this.$rootScope.$emit("SetPayForPostData", {
              cards: true,
              event: event,
            });
            $("#modal-pick-card").modal();
          }, 1000);
        }
      }
    } else {
      console.log("we are down here...");

      _this.$timeout(function () {
        $("#modal-publish-event").modal("toggle");
      }, 500);

      if (type === 2) {
        publish_status = false;
      } else {
        publish_status = true;
      }

      console.log("what is the status....");
      console.dir(publish_status);

      _this.$timeout(function () {
        _this.$rootScope.$emit("SetPublishType", {
          status: publish_status,
        });
      });
    }
  }

  promoteJob(event) {
    var _this = this;
    _this.promote_job = event;
    _this.$timeout(function () {
      $("#promote-job").modal();
    });
  }

  closePromoteModal() {
    var _this = this;
    _this.$timeout(function () {
      $("#promote-job").modal("toggle");
    });
  }

  confirmPromote() {
    var _this = this;

    _this.setLoader();
    _this.$events.promote_event(_this.promote_job.jobblePoolId).then(
      function (response) {
        _this.unSetLoader();
        if (response.data.status === "OK") {
          _this.closePromoteModal();
          _this.$timeout(function () {
            alert("Your job was successfully promoted.");
          }, 500);
        } else {
          _this.closePromoteModal();
          _this.$timeout(function () {
            alert(response.data.message);
          }, 500);
        }
      },
      function (error) {
        _this.unSetLoader();
        _this.closePromoteModal();
        _this.$timeout(function () {
          alert("There was an error promoting your job. Please contact customer support.");
        }, 500);
      }
    );
  }

  closePublishModal() {
    var _this = this;
    _this.$timeout(function () {
      $("#modal-publish-event").modal("toggle");
    }, 500);
  }

  closePromote() {
    var _this = this;
    _this.$timeout(function () {
      $("#promote-job").modal("toggle");
    });
  }

  closeModalAndCharge(params) {
    var _this = this;
    console.log("closeModalAndCharge");
    console.dir(params);
    console.dir(params.status);
    let status = params.status;
    let card = params.card;
    let data = {};
    let invoice = params.message;
    if (invoice !== true) {
      data.token = card.stripeId;
    }
    data.amount = 5000;
    data.user = "accounting@jobble.com";
    data.note = "Payment for job posting.";
    _this.event = params.event;
    _this.remain_loading_count = 1;
    console.log("****what is the status****");
    console.dir(status);
    if (status) {
      status = params.status;
    }

    _this.$companies.chargeForPost(data, invoice).then(
      function (response) {
        _this.remain_loading_count = 0;
        if (response.status === "error") {
          alert("There was an issue with your payment method : " + response.message);
        }
        let id = params.event.subEvents[0].deduppedJobbles[0].id;
        _this.$events.markJobblesAsPublished(id, _this.event, status).then(
          function (response) {
            console.log("response from mark jobbles as publshed....");
            console.dir(response);
            console.dir(invoice);
            if (invoice === true) {
              _this.markEventAsPublished({
                event: _this.event.id,
                status: status,
              });
              //_this.closePublishModal();
              _this.remain_loading_count = 0;
              _this.unSetLoader();
            } else {
              if (params.new_card === true) {
                _this.markEventAsPublished({
                  event: params.event.id,
                  status: params.status,
                  do_not_close: true,
                });
              } else {
                _this.$timeout(function () {
                  $("#modal-pick-card").modal("toggle");
                }, 300);
                _this.$timeout(function () {
                  _this.markEventAsPublished({
                    event: _this.event.id,
                    status: status,
                    do_not_close: true,
                  });
                  _this.remain_loading_count = 0;
                }, 600);
              }
            }
          },
          function (error) {
            alert("error publishing event");
          }
        );
      },
      function (error) {
        alert("There was an error charging your card. Please contact support");
      }
    );
  }

  expandJobsTable() {
    var _this = this;

    console.log("expandJobsTable");
    console.dir(_this.table_expanded);

    if (!_this.table_expanded) {
      _this.table_expanded = true;

      console.log("do we have this...");
      console.dir($(".jobs-sidebar-complete"));
      console.dir($(".jobs-page-complete"));

      _this.$timeout(function () {
        $(".sticky-header").addClass("sticky-header-expanded-headers");
        $(".job-content .job-table.table-responsive.respons-job table tbody tr").addClass("sticky-body-expanded-cells");
        $(".jobs-sidebar-complete").addClass("jobs-sidebar-complete-hide");
        $(".jobs-page-complete").addClass("jobs-page-complete-expanded");
      }, 100);
    } else {
      _this.table_expanded = false;
      _this.$timeout(function () {
        $(".jobs-sidebar-complete").removeClass("jobs-sidebar-complete-hide");
        $(".jobs-page-complete").removeClass("jobs-page-complete-expanded");
      }, 100);
    }
  }

  checkToClearQuery(clear) {
    var _this = this;
    if (clear) {
      _this.$rootScope.sessionParams = null;
    }
  }
}

EventsController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "events",
  "companies",
  "security",
  "$rootScope",
  "$timeout",
  "$window",
  "$location",
  "$stateParams",
  "scroll",
  "env",
  "$scope",
  "NgMap",
  "branchio",
];

export default EventsController;



// WEBPACK FOOTER //
// ./client/app/components/events/events.controller.js